export default "__VITE_ASSET__DTYImkX___"